/**
 * @description 格式化操作
 */

/********************/

/**
 * @description 格式成 xxxx-xx-xx （星期x）  xx:xx-xx:xx || xxxx-xx-xx xx:xx-xx:xx
 * @param startTime <number, 开始时间：13位时间戳, 必选>
 * @param endTime <number, 结束时间：13位时间戳, 必选>
 * @param showWeek <Boolean, 是否显示星期, 可选>
 * @returns { string }
 */

export function formatExamTime(startTime, endTime, showWeek = true) {
  const startDate = new Date(startTime);
  const endDate = new Date(endTime);
  const year = startDate.getFullYear();
  const month = (startDate.getMonth() + 1).toString().padStart(2, "0");
  const date = startDate.getDate().toString().padStart(2, "0");
  const day = ["日", "一", "二", "三", "四", "五", "六"][startDate.getDay()];
  const hours = startDate.getHours().toString().padStart(2, "0");
  const minute = startDate.getMinutes().toString().padStart(2, "0");

  const endHours = endDate.getHours().toString().padStart(2, "0");
  const endMinute = endDate.getMinutes().toString().padStart(2, "0");

  if (showWeek)
    return `${year}-${month}-${date} (星期${day}) ${hours}:${minute}-${endHours}:${endMinute}`;
  return `${year}-${month}-${date}  ${hours}:${minute}-${endHours}:${endMinute}`;
}

/**
 * @description 格式成 xx小时xx分钟 || xx分钟 || xx秒
 * @param startTime <number, 开始时间：10位时间戳, 必选>
 * @param endTime <number, 结束时间：10位时间戳, 必选>
 * @returns { string }
 */
export function duration(startTime, endTime) {
  let timeDiff = endTime - startTime;
  const hours = Math.floor(timeDiff / 3600);
  timeDiff = timeDiff % 3600;
  const minute = Math.floor(timeDiff / 60);
  timeDiff = timeDiff % 60;
  const seconds = Math.floor(timeDiff);
  if (hours) {
    if (minute) {
      return `${hours}小时${minute}分钟`;
    } else {
      return `${hours}小时`;
    }
  } else if (minute) {
    return `${minute}分钟`;
  } else {
    return `${seconds}秒`;
  }
}

/**
 * @description 格式成 xx-xx
 * @param time <number, 开始时间：13位时间戳, 必选>
 * @returns { string }
 */

export function formatTime(time) {
  const date = new Date(time);
  const hours = date.getHours().toString().padStart(2, "0");
  const minute = date.getMinutes().toString().padStart(2, "0");
  return `${hours}:${minute}`;
}

/**
 * @description 格式成 xxxx-xx-xx xx:xx
 * @param timeStamp <number, 开始时间：13位时间戳, 必选>
 * @returns { string }
 */

export function formatWrongTime(timeStamp) {
  if (!timeStamp) return "-";
  const time = new Date(timeStamp);
  const year = time.getFullYear();
  const month = (time.getMonth() + 1).toString().padStart(2, "0");
  const date = time.getDate().toString().padStart(2, "0");
  const hours = time.getHours().toString().padStart(2, "0");
  const minute = time.getMinutes().toString().padStart(2, "0");

  return `${year}-${month}-${date} ${hours}:${minute}`;
}

/**
 * @desc 格式化视频或音频的时长转化为标准化的xx:xx:xx || xx:xx 格式
 * @param { number } duration
 * @return {String}
 */

export const formatDuration = (duration) => {
  const time = parseInt(duration);
  if (time > -1) {
    var hour = Math.floor(time / 3600);
    var min = Math.floor(time / 60) % 60;
    var sec = time % 60;

    hour = hour > 0 ? hour.toString().padStart(2, "0") : 0;
    min = min.toString().padStart(2, "0");
    sec = sec.toString().padStart(2, "0");

    if (hour) return `${hour}:${min}:${sec}`;
    return `${min}:${sec}`;
  }
  return duration;
};

/**
 * @description 考试倒计时： xx:xx:xx
 * @param endTime <number, 考试结束时间：10位时间戳, 必选>
 * @returns { string }
 */
export function examDuration(examEndTime) {
  let timeDiff = examEndTime - new Date().getTime() / 1000;
  const hours = Math.floor(timeDiff / 3600)
    .toString()
    .padStart(2, "0");
  timeDiff = timeDiff % 3600;
  const minute = Math.floor(timeDiff / 60)
    .toString()
    .padStart(2, "0");
  timeDiff = timeDiff % 60;
  const seconds = Math.floor(timeDiff).toString().padStart(2, "0");
  return `${hours}:${minute}:${seconds}`;
}

/**
 * @description 将接口返回结果转换成一般化的json
 * @param data <Array, 数据, 必选>
 * @returns { Object }
 */
export function toClientData(data) {
  try {
    let res = {};

    data.forEach((item) => {
      let temp = res; //temp指向当前key所在层次的父对象
      let keyArr = item.string_id.split("_");
      // console.log(keyArr);
      let isContinue = true;
      keyArr.forEach((key, index) => {
        if (index == keyArr.length - 1) {
          temp[key] = item.value;
        } else {
          // 当前属性对象不存在 则赋空对象
          // 存在 则让temp = temp[key] 指向下一级对象
          if (temp[key] && typeof temp[key] == "string") isContinue = false;
          if (isContinue) {
            temp[key] ? (temp = temp[key]) : (temp = temp[key] = {});
          }
        }
      });
    });
    return res;
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 浮点数 保留精度
 * @param {*} x 浮点数
 * @param {*} n 保留精度位数
 * @return {*}
 */
export function toFixed(x, n) {
  return Number.parseFloat(x).toFixed(n);
}
